import React from "react"

const Footer = () => {
  return (
    <footer className="footer_area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="footer_top flex-column">
              <div className="footer_social">
                <a href="#home">
                  <img src="img/logo.png" alt="" />
                </a>
                <h4>Follow Me</h4>
              </div>
              <div className="footer_social">
                <a href="https://facebook.com" rel="noreferrer" target="_blank">
                  <i className="fa fa-facebook"></i>
                </a>
                <a
                  href="https://github.com/ryncrdl"
                  rel="noreferrer"
                  target="_blank"
                >
                  <i className="fa fa-github"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/ryan-cordial"
                  rel="noreferrer"
                  target="_blank"
                >
                  <i className="fa fa-linkedin"></i>
                </a>
                <a
                  href="https://instagram.com/_ryxzer"
                  rel="noreferrer"
                  target="_blank"
                >
                  <i className="fa fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row footer_bottom justify-content-center">
          <p className="col-lg-8 col-sm-12 footer-text">
            Ryan Cordial &copy; {new Date().getFullYear()} All rights reserved
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
